import m from "../../../../geodata/es2015/region/world/asiaUltra";
window.am4geodata_region_world_asiaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/asiaUltra.js
// module id = null
// module chunks = 